<div class="flex flex-nowrap overflow-x-auto gap-3 mb-2 p-1">
  @for (item of summary(); track item.depositTypeId) {
    <div
      class="shadow-module bg-white rounded-xl flex-1 min-w-44 h-summary-card shrink-0 flex flex-col gap-2.5 px-2 py-3"
    >
      <h3 class="text-body-sm-600 text-surface-700 m-0">{{ item.name }}</h3>
      <div class="flex flex-col gap-2">
        <div class="flex justify-between items-center">
          <span class="text-body-2xs-500 text-surface-700">Scheduled</span>
          <span class="text-body-xs-600 text-surface-700">{{ item.scheduled | currencyFormat }}</span>
        </div>
        <div class="flex justify-between items-center">
          <span class="text-body-2xs-500 text-surface-700">Paid</span>
          <span class="text-body-xs-600 text-emerald-700">{{ item.received | currencyFormat }}</span>
        </div>
        <div class="flex justify-between items-center">
          <span class="text-body-2xs-500 text-slate-700">Due</span>
          <span class="text-body-xs-600 text-red-500">{{ item.due | currencyFormat }}</span>
        </div>
      </div>
    </div>
  }
</div>
